/// <amd-module name="Test/Analytics/TestAnalyticsTrendChart/ControllerViews/TestInsightsTrendChart" />
import { ColumnChartVisual, IColumnChartVisualProps } from "Analytics/Shared/Visuals/ColumnChartVisual/Components/ColumnChartVisual";
import * as React from "react";
import { TestInsightsTrendChartActionsCreator } from "Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActionsCreator";
import { ITestInsightsTrendChartState, TestInsightsTrendChartStore } from "Test/Analytics/TestAnalyticsTrendChart/Stores/TestInsightsTrendChartStore";
import { css, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface ITestInsightsTrendChartProps extends IVssComponentProperties {
    store: TestInsightsTrendChartStore;
    actionCreator: TestInsightsTrendChartActionsCreator;
}

export class TestInsightsTrendChart extends VssComponent<ITestInsightsTrendChartProps, ITestInsightsTrendChartState> {
    constructor(props: ITestInsightsTrendChartProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {} as ITestInsightsTrendChartState;
    }

    public componentDidMount(): void {
        if (this.props) {
            this.props.store.addChangedListener(this._onStoreUpdate);
            this.setState(this.props.store.getState());
        }
    }

    public componentWillUnmount(): void {
        this.props.store.removeChangedListener(this._onStoreUpdate);
    }

    public render(): JSX.Element {
        const chartVisualProps = this._getColumnChartVisualProperties();
        if (chartVisualProps) {
            return <ColumnChartVisual {...chartVisualProps} />;
        } else {
            return (
                <Spinner
                    className={css(
                        "new-testinsights-analytics-report-view-chartsarea analytics-card-spinner flex-column",
                        this.props.className || ""
                    )}
                    size={SpinnerSize.large}
                />
            );
        }
    }

    private _getColumnChartVisualProperties(): IColumnChartVisualProps | null {
        if (!this.state.chartOptions || Object.keys(this.state.chartOptions).length === 0) {
            return null;
        }

        this.state.chartOptions.pageContext = this.context.pageContext;
        return {
            chartOptions: this.state.chartOptions,
            columnChartLabelledMenuProps: {
                metricOptions: this.state.metricOptions,
                selectedMetricOption: this.state.selectedMetricOption
            },
            className: css("new-testinsights-analytics-report-view-chartsarea relative", this.props.className || ""),
            style: this.props.style
        } as IColumnChartVisualProps;
    }

    private _onStoreUpdate = () => {
        this.setState(this.props.store.getState());
    };
}
